import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import { Router, Route } from 'react-router-dom'
import I18n from 'redux-i18n'
import 'moment/locale/nl';
import 'moment/locale/fr';


import { arrayFindPolyfill } from './helpers/arrayFindPolyfill'
import { arrayIncludesPolyfill } from './helpers/arrayIncludesPolyfill'
import { SVGClassListShim } from './helpers/SVGClassListShim'
import { ObjectDotKeysPolyfill } from './helpers/ObjectDotKeysPolyfill'

import { requireAuth } from './actions/acLogin'
import { errorReportConfig, gtmID } from './config'
import { translations } from './translations'
import { history } from './history'
import configureStore from './store'
import App from './App';

import './index.css';
import './style.css'

// Array.prototype.find do not exist in IE
arrayFindPolyfill()
// Array.prototype.includes do not exist in IE
arrayIncludesPolyfill()
// ClassList for SVGs do not exist in IE, which breaks the ".contains" method on pages with SVGs
SVGClassListShim()
// This actually crashed for a u̶s̶e̶r̶ caveman
ObjectDotKeysPolyfill()

const store = configureStore()

if (process.env.NODE_ENV === 'production'){
	/* eslint-disable */
	const gTagManager = (w,d,s,l,i) => {
		w[l]=w[l]||[];w[l].push({'gtm.start':
		new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
		j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
		'//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
	}
	/* eslint-enable */
	gTagManager(window, document, 'script', "dataLayerGTM", gtmID);
}

store.dispatch(requireAuth())

// Sentry config:
errorReportConfig.install();

ReactDOM.render(
	<Provider store={store}>
		<I18n translations={translations}>
			<Router history={history}>
				<Route path="/" component={App}/>
			</Router>
		</I18n>
	</Provider>,
	document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js